import React, { useState, useEffect } from 'react';
import { useTrailUgcContext } from 'components/trailUgc/TrailUgcContext';
import { TrailId } from 'types/Trails';
import SortOption from 'components/trailUgc/types/SortOption';
import { logTrailDetailsSortingMethodChanged } from 'utils/trail_analytics_helpers';
import * as styles from './styles/styles.module.scss';
import { StringConstantsMixin } from '../../../application/javascripts/react_components/mixins/shared/string_constants_mixin';

export type UgcSortDropdownProps = {
  enabledSortLinks: SortOption[];
  selectedSort: SortOption;
  onSortSelected: (newSort: SortOption) => void;
  trailId?: TrailId;
};

const UgcSortDropdown = ({ trailId, enabledSortLinks, selectedSort, onSortSelected }: UgcSortDropdownProps): JSX.Element => {
  const { selectedUgcTab } = useTrailUgcContext().ugcState;
  const [selectedSortOption, updateSelectSort] = useState(selectedSort);

  useEffect(() => {
    if (selectedSort && selectedSortOption !== selectedSort) {
      updateSelectSort(selectedSort);
    }
  }, [selectedSort, selectedSortOption]);

  const handleSortClick = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const newSort = e.target.value as SortOption;
    logTrailDetailsSortingMethodChanged(trailId, newSort, selectedSort, selectedUgcTab);
    updateSelectSort(newSort);
    onSortSelected(newSort);
  };

  return (
    <div className={`${StringConstantsMixin.constants.XLATE.NONE} ${styles.container}`}>
      <div className={styles.labelAndSelect}>
        <div>{StringConstantsMixin.strings.FILTERS.SORT}:</div>
        <select onChange={handleSortClick} className={styles.select} value={selectedSortOption}>
          {enabledSortLinks.map(sortKey => (
            <option key={sortKey} value={sortKey}>
              {StringConstantsMixin.strings.SORT[sortKey]}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default UgcSortDropdown;
